<template>
      <div class="page page-inner">
        <breadcrumb title="Leave Request"></breadcrumb>
        <div class="card card-fluid">
          <!-- .card-header -->
          <div class="card-header nav-scroller">
            <!-- .nav-tabs -->
            <ul class="nav nav-tabs card-header-tabs">
              <li class="nav-item">
                <a href="#" class="nav-link active" @click.prevent="setActive('leave-request')" data-toggle="tab" >Leave Request</a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" @click.prevent="setActive('leave-approval')" data-toggle="tab" >Leave Approval</a>
              </li>
            </ul>
            <!-- /.nav-tabs -->
          </div>
          <!-- /.card-header -->

          <!-- .card-body -->
          <div class="card-body">
            <div class="tab-content py-3" >
              <div class="tab-pane fade" :class="{ 'active show': isActive('leave-request') }" id="home">
                <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div class="dt-buttons btn-group">
                        <button class="btn btn-success btn-modal" v-show="action_button.add" tabindex="0" v-b-modal.modal-request type="button" data-title="Request">
                          <span>Request</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div id="data-table-leave-request-request_filter" class="dataTables_filter"><label>Search:<input
                          type="search" class="form-control" placeholder=""
                          aria-controls="data-table-leave-request-request"></label></div>
                    </div>
                  </div>

                    <b-table :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy"
                             :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" hover class="table-height" :class="{'hide-scroll': isScrollHide()}">

                        <template v-slot:cell(action)="row">
                          <a class="btn btn-xs"  @click="info(row.item, row.index, $event.target)" title="[Detail]" data-title="[Detail]" v-show="action_button.detail" >
                            <em class="fa fa-search"></em>
                          </a>
                          <a class="btn btn-xs"  @click="editRow(row.item, row.index, $event.target)" title="Edit" data-title="Edit" v-if="row.item.leave_stat_id === 0 && action_button.edit">
                            <em class="fa fa-pencil-alt"></em>
                          </a>
                          <a class="btn btn-xs"  @click="deleteRow(row.item, row.index, $event.target)" title="Delete" data-title="Delete" v-if="row.item.leave_stat_id === 0 && action_button.delete ">
                            <em class="fa fa-trash"></em>
                          </a>
                        </template>
                    </b-table>
                    <div class="row align-items-center">
                      <pagination-info :rows="rows" :per-page="perPage" :current-page="currentPage"></pagination-info>
                      <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                        <div class="dataTables_paginate paging_simple_numbers">
                          <b-pagination v-model="currentPage" v-on:click="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <div class="tab-pane fade" :class="{ 'active show': isActive('leave-approval') }" id="profile">
                <div id="data-table-leave-request-approval_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div id="data-table-leave-approval-request_filter" class="dataTables_filter"><label>Search:<input
                          type="search" class="form-control" placeholder=""
                          aria-controls="data-table-leave-request-request"></label></div>
                    </div>
                  </div>

                  <b-table hover :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy"
                           :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" class="table-height" :class="{'hide-scroll': isScrollHide()}">

                    <template v-slot:cell(action)="row">
                      <a class="btn btn-xs"  @click="info(row.item, row.index, $event.target)" title="[Detail]" data-title="[Detail]" >
                        <em class="fa fa-search"></em>
                      </a>
                    </template>
                  </b-table>
                  <div class="row align-items-center">
                    <pagination-info :rows="rows" :per-page="perPage" :current-page="currentPage"></pagination-info>
                    <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                      <div class="dataTables_paginate paging_simple_numbers">
                        <b-pagination v-model="currentPage" v-on:click="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.card-body -->
        </div>
        <leave-request-input :option_leave_type="option_leave_type"  :dataEdit="dataEdit" ref="mdl"></leave-request-input>
        <leave-request-detail :detail="emp_item"></leave-request-detail>
        <b-modal id="modal-delete" hide-backdrop content-class="shadow" ref="modal-delete" title="Delete" @ok="deleteItem" @hide="resetModal" ok-title="Delete" ok-variant="danger">
          <p class="my-2">
           Are you sure delete this item ?
          </p>
        </b-modal>
      </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import LeaveRequestDetail from "@/components/pages/leave-request/LeaveRequestDetail";
import LeaveRequestInput from "@/components/pages/leave-request/LeaveRequestInput";
import {BTable, BModal, VBModal,  BPagination} from "bootstrap-vue"
import {mapGetters} from "vuex";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api"
import PaginationInfo from "../../PaginationInfo";
import Acl from "../../../../libs/AclButton";
export default {
  name: "LeaveRequest",
  components:{
    PaginationInfo,
    Breadcrumb,
    BTable,
    BModal,
    'v-b-modal':VBModal,
    BPagination,
    LeaveRequestDetail,
    LeaveRequestInput
  },
  directives: {
    'b-modal': VBModal
  },
  data(){
    return {
      activeItem:"leave-request",
      noCollapse:false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      emp_item:{},
      items:[],
      rows:0,
      perPage:20,
      currentPage:1,
      fields: [
        { key: 'no', sortable: true , thStyle: {maxWidth: '60px', minWidth: '10px'}},
        { key: 'action', sortable: true, thStyle: {maxWidth: '150px', minWidth: '10px'} },
        { key: 'number', sortable: true },
        { key: 'emp_name',label:'Staff', sortable: true },
        { key: 'tipe_name', label:'Leave Type', sortable: true },
        { key: 'start',label:'Start Time', sortable: true },
        { key: 'end', sortable: true },
        { key: 'day_count', sortable: true },
        { key: 'project_name',label:'Project', sortable: true },
        { key: 'contact_name', label:'PIC During Leave', sortable: true },
        { key: 'leave_stat_name',label:'Status',  sortable: true },
      ],
      option_leave_type:[{text:"Anual Leave", code:"anual_leave"}, {text:"Sick Leave", code: "sick_leave"}],
      dataEdit:null,
      action_button:{
        add : false,
        delete: false,
        edit: false,
        detail:false
      }
    }
  },
  computed:{
    ...mapGetters([ 'scrollbarHide']),
  },
  watch:{
    currentPage:function (){
     this.getData()
    }
  },
  methods:{
    isScrollHide(){
      return this.scrollbarHide
    },
    setActive(itemTabs){
      this.activeItem = itemTabs
      this.getData()
    },
    isActive(itemTabs){
      return this.activeItem === itemTabs
    },
    info(item, index, button) {
      this.emp_item = item
      this.$root.$emit('bv::show::modal', 'modal-request-detail', button)
    },
    editRow(item, index){
      this.dataEdit = item
      this.$refs.mdl.$refs['modal'].show()
    },
    deleteRow(item){
      this.dataEdit = item
      this.$refs['modal-delete'].show()
    },
    resetModal(){
      this.dataEdit = null
    },
    getData(){
      this.items = []
      let userProfile = this.$store.getters.userProfile
      let payload = {
        emp_id: this.$store.getters.empId,
        lang:"en",
        company_id:userProfile.data.attributes.company_id,
        page:this.currentPage,
        limit:this.perPage
      }

      if(this.activeItem === "leave-approval") payload.approval = true
     AxiosCall.Get(payload, urlApi.leave_request.get_data).then(resp=>{
      if (resp.success){
        let no = (this.currentPage - 1) * this.perPage + 1
        for (let data of resp.atributes){
          data.no = no++
          data.start = data.start.replace("T", " ").replace("Z", "")
          data.end = data.end.replace("T", " ").replace("Z", "")
          let donor  = data.donor || ""
          let project_abbreviation = data.project_abbreviation || ""
          let var_name = data.var_name || ""
          data.project_name = project_abbreviation +" - "+ donor + "\n"+ var_name
          this.items.push(data)
        }
        this.rows = resp.total
      }

     }).catch(e=>{
       this.errorMessage(e.response.data.message)
     })
    },
    getLeaveType(){
      let userProfile = this.$store.getters.userProfile
      let payload = {company_id:userProfile.data.attributes.company_id}
      AxiosCall.Get(payload, urlApi.leave_request.leave_type_list).then(res=>{
        if (res.success){
          this.option_leave_type = res.atributes
        }
      })
    },
    deleteItem(evt){
      evt.preventDefault()
      AxiosCall.Delete(urlApi.leave_request.delete+"/"+this.dataEdit.id).then(res=>{
        if (res.success){
          this.successMessage(res.message)
        }else{
          this.errorMessage(res.message)
        }
        this.getData()
        this.$refs["modal-delete"].hide()
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    checkAction(){
      for(let act in this.action_button){
          this.action_button[act] = Acl(this.$options.name, act)
      }
    }
  },
  mounted() {
    this.checkAction()
    this.getData()
    this.getLeaveType()
  }
}
</script>

<style lang="css" scoped>

@media (min-width: 992px) {
  .modal .modal-huge {
    max-width: 90% !important;
    width: 90% !important;
  }
}
@media (min-width: 768px) {
  .table .b-table .table-hover {
    display: block;
    height: auto !important;
    visibility: visible;
  }
}
.pagination {
  width:90%;
  float: right;
}
.pagination-content {
  width: 100%;
}
@import  '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~flatpickr/dist/flatpickr.css';
@import '~vue-select/dist/vue-select.css';



</style>
